import { ReactComponent as CheckMarkIcon } from "../../assets/icons_svg/check-mark-outline.svg";
import Button from '../../common/Button/Button';
import './PricingTiers.scss';

export default function PricingTiers({ onClickPlan }) {
  return (
    <div className="__pricing-tiers">
      <div className='pricing-plan'>
        <div className='plan-name'>Free</div>
        <div className='pricing'>
          <div className='amount'>$0</div>
          <div className='cadence'>free forever</div>
        </div>
        <div className='plan-description'>
          Get your leads organized today.
        </div>
        <ul className="features">
          <li><CheckMarkIcon /><span>1 business</span></li>
          <li><CheckMarkIcon /><span>1 user</span></li>
          <li><CheckMarkIcon /><span>1,000 leads</span></li>
          <li><CheckMarkIcon /><span>List & kanban views</span></li>
          <li><CheckMarkIcon /><span>Webhooks, Zapier & API</span></li>
        </ul>
        <Button onClick={() => onClickPlan('free')} variant='muted'>Start free</Button>
      </div>

      <div className='pricing-plan main-plan'>
        <div className='plan-name'>Pro</div>
        <div className='pricing'>
          <div className='amount'>$29</div>
          <div className='cadence'>per month</div>
        </div>
        <div className='plan-description'>
          For growing sales teams.
        </div>
        <ul className="features">
          <li><CheckMarkIcon /><span>1 business</span></li>
          <li><CheckMarkIcon /><span>10 user</span></li>
          <li><CheckMarkIcon /><span>100,000 leads</span></li>
          <li><CheckMarkIcon /><span>CSV import</span></li>
          <li><CheckMarkIcon /><span>Automatic lead assignment</span></li>
        </ul>
        <Button onClick={() => onClickPlan('pro')} variant='primary'>Get Pro</Button>
      </div>

      <div className='pricing-plan'>
        <div className='plan-name'>Agency</div>
        <div className='pricing'>
          <div className='amount'>$99</div>
          <div className='cadence'>per month</div>
        </div>
        <div className='plan-description'>
          For agencies managing many clients.
        </div>
        <ul className="features">
          <li><CheckMarkIcon /><span>100 businesses</span></li>
          <li><CheckMarkIcon /><span>1,000 users</span></li>
          <li><CheckMarkIcon /><span>100 million leads</span></li>
          <li><CheckMarkIcon /><span>CSV import</span></li>
          <li><CheckMarkIcon /><span>Automatic lead assignment</span></li>
        </ul>
        <Button onClick={() => onClickPlan('agency')} variant='muted'>Get Agency</Button>
      </div>
    </div>
  )
}
